import { createStore } from "vuex";
import VuexPersistence from "vuex-persist";
import * as actions from "./actions";
import * as mutations from "./mutations";
import * as getters from "./getters";
import { initialState, storageAdapter } from "../utils/stateUtils";

const persist = new VuexPersistence({
  storage: storageAdapter,
  reducer: (state) => {
    const { components, templates, fonts, currentUser, creatives, currentTenant, childTenants } = state;
    return { components, templates, fonts, currentUser, creatives, currentTenant, childTenants };
  },
  key: "_ADCTV_CACHE_",
});

export default createStore({
  state: initialState(),
  mutations: mutations,
  actions,
  getters,
  modules: {},
  plugins: [persist.plugin],
});
